// KonamiEgg.jsx — ↑↑↓↓←→←→BA easter egg → arcade power-up + fanfare
import React from "react";
import { useT } from "../i18n/useT.js";
import Arcade from "./arcade/Arcade.jsx";

const KONAMI = [
  "ArrowUp","ArrowUp","ArrowDown","ArrowDown",
  "ArrowLeft","ArrowRight","ArrowLeft","ArrowRight",
  "b","a",
];

function playFanfare() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  const ctx = new AC();
  const notes = [
    { f: 523.25, t: 0.00, d: 0.10 },
    { f: 659.25, t: 0.10, d: 0.10 },
    { f: 783.99, t: 0.20, d: 0.10 },
    { f: 1046.5, t: 0.30, d: 0.20 },
  ];
  const now = ctx.currentTime;
  notes.forEach((n) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "square";
    o.frequency.value = n.f;
    g.gain.setValueAtTime(0.0001, now + n.t);
    g.gain.exponentialRampToValueAtTime(0.18, now + n.t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, now + n.t + n.d);
    o.connect(g).connect(ctx.destination);
    o.start(now + n.t);
    o.stop(now + n.t + n.d + 0.02);
  });
}

export default function KonamiEgg() {
  const t = useT();
  const [show, setShow] = React.useState(false);
  const bufRef = React.useRef([]);

  React.useEffect(() => {
    const onKey = (e) => {
      const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      bufRef.current.push(k);
      if (bufRef.current.length > KONAMI.length) {
        bufRef.current = bufRef.current.slice(-KONAMI.length);
      }
      if (bufRef.current.join(",") === KONAMI.join(",")) trigger();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function trigger() {
    setShow(true);
    try { playFanfare(); } catch (e) {}
    try { Arcade.powerUp(); } catch (e) {}
    document.body.classList.add("konami-turbo");
    setTimeout(() => {
      setShow(false);
      document.body.classList.remove("konami-turbo");
    }, 3200);
  }

  if (!show) return null;
  return (
    <div className="konami-toast" role="status">
      {t("konami.toast").split("\n").map((line, i) => (
        <div key={i} style={{ marginBottom: 6 }}>{line}</div>
      ))}
    </div>
  );
}
